import React from 'react';
/**
 * shows the icon for post requests
 */
export default function PostLoading() {
    return (<div className="loading text-center">
         <img src="/images/post_loading.gif" alt="" />
    </div>)
}